export const getCurrentLocation = () => {
    return new URL(window.location.origin + window.location.hash.replace('#', ''));
};
